import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";

const SquareCheckbox = (props) => (
    <Checkbox
        {...props}
        disableRipple
        icon={
            <Box
                sx={{
                    width: 16,
                    height: 16,
                    border: "1.5px solid #BEBEBE",
                    backgroundColor: "transparent",
                }}
            />
        }
        checkedIcon={
            <Box
                sx={{
                    width: 16,
                    height: 16,
                    backgroundColor: "#111111",
                    border: "1.5px solid #111111",
                    boxShadow: "inset 0 0 0 2px #FFFFFF",
                }}
            />
        }
    />
);
export default SquareCheckbox
